import store from '~/store'

export const timeZoneCheck = (conf) => {
  let tz = 'Europe/Berlin'
  const config = conf
  let eventTz = ''
  if (config) {
    eventTz = config.config[0].EventTimeZone
  }
  if (eventTz) tz = eventTz
  return tz
}

export const eventTimezone = () => {
  const timeZoneConfig = store.getters['config/configForKey']('app_config')
  const defaultTimeZone = store.getters['instancesState/getInstance'] === 'us' ? 'US/Eastern' : 'Europe/Berlin'
  return timeZoneConfig.config[0].EventTimeZone ? timeZoneConfig.config[0].EventTimeZone : defaultTimeZone
}
export const selectedTimezone = () => {
  return localStorage.getItem('selectedTimezone') ? localStorage.getItem('selectedTimezone') : eventTimezone()
}

export const timeConfig = () => {
  const config = store.getters['config/configForKey']('app_config').configV2.defaultV2
  return config.timeConfig || null
}

// export const eventTimezone = () => {
//   const defaultTimeZone = store.getters['instancesState/getInstance'] === 'us' ? 'US/Eastern' : 'Europe/Berlin'
//   return timeZoneConfig.config[0].EventTimeZone ? timeZoneConfig.config[0].EventTimeZone : defaultTimeZone
// }
// export const selectedTimezone = () => {
//   return localStorage.getItem('selectedTimezone') ? localStorage.getItem('selectedTimezone') : eventTimezone()
// }

export const timeFormat = () => {
  return timeConfig() && timeConfig().timeFormat ? timeConfig().timeFormat  : 'HH:mm'
}

export const dateFormat = () => {
  return timeConfig() && timeConfig().dateFormat  ? timeConfig().dateFormat  : 'Do MMMM YYYY, HH:mm'
}
